import classnames from 'classnames'
import React from 'react'

// Utils

import { Image as ImageC } from '@src/quince-components/src'
import Image from '@src/quince-site-common/src/domains/Image'

// Styles
import stylesV2 from './product-details-icon-v2.module.scss'
import styles from './product-details-icon.module.scss'
export enum PRODUCT_DETAILS_ICONS {
  MINIMAL_PACKAGING = 'minimalPackaging',
  OEOKO_CERTIFIED_SVG = 'oeokoCertifiedSvg',
  REDUCED_CARBON_FOOTPRINT = 'reducedCarbonFootpring',
}

export interface ProductDetailsIconProps {
  displayTitle: string
  image?: Image
  showPdpV2UI?: boolean
}

const ProductDetailsIcon = ({ displayTitle, image, showPdpV2UI }: ProductDetailsIconProps) => {
  const finalStyles = showPdpV2UI ? stylesV2 : styles
  const classes = classnames(finalStyles.icons)
  return (
    <div className={classes}>
      {image && <ImageC {...image} className={finalStyles.icons__iconWrapper} />}
      <div className={finalStyles.icons__iconText}>{displayTitle}</div>
    </div>
  )
}

export default ProductDetailsIcon
